import { useEffect, useState } from "react";
import useDataFetch from "./useDataFetch";

export interface ConnectedAccountStateDTO {
    accountId: string;
    chargesEnabled: boolean;
    payoutsEnabled: boolean;
    detailsSubmitted: boolean;
    hasPendingRequirements: boolean;
    hasPastDueRequirements: boolean;
    hasErrors: boolean;
    hasEventuallyDueRequirements: boolean;
}

const useStripeCheckAccount = (societySecured: boolean) => {
    const [connectedAccountState, setConnectedAccountState] = useState<ConnectedAccountStateDTO>();
    const [isConnectedAccountReady, setIsConnectedAccountReady] = useState<boolean>(false);
    const [hasConnectedAccount, setHasConnectedAccount] = useState<boolean>(false);
    const [hasDetailsSubmitted, setHasDetailsSubmitted] = useState<boolean>(false);
    const [isLoadingConnectedAccountState, setIsLoadingConnectedAccountState] = useState<boolean>(false);

    const { fetchDataPromise: retrieveConnectedAccountState } = useDataFetch<ConnectedAccountStateDTO>(
        `/stripe/connected-account/retrieve-connnected-account`,
        true,
        false
    );

    useEffect(() => {
        if (societySecured) {
            setIsLoadingConnectedAccountState(true);
            retrieveConnectedAccountState(`/stripe/connected-account/retrieve-connnected-account`)
                .then((response) => {
                    if (response.data) {
                        setConnectedAccountState(response.data);
                    }
                })
                .finally(() => setIsLoadingConnectedAccountState(false));
        }
    }, [societySecured]);

    useEffect(() => {
        if (connectedAccountState) {
            if (connectedAccountState.detailsSubmitted) {
                setHasDetailsSubmitted(true);
            }
            if (connectedAccountState.accountId) {
                setHasConnectedAccount(true);
                if (
                    connectedAccountState.chargesEnabled &&
                    connectedAccountState.payoutsEnabled &&
                    connectedAccountState.detailsSubmitted &&
                    !connectedAccountState.hasPendingRequirements &&
                    !connectedAccountState.hasPastDueRequirements
                ) {
                    setIsConnectedAccountReady(true);
                }
            }
        }
    }, [connectedAccountState]);

    return {
        isConnectedAccountReady,
        hasConnectedAccount,
        hasDetailsSubmitted,
        isLoadingConnectedAccountState,
    };
};

export default useStripeCheckAccount;
